var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper mainFlexColumn"},[_vm._t("default")],2),(_vm.getReseller.claimGuideTab === 'true')?_c('claim-guide-tab'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }